import { DiscoverQs } from '@src/types/Discover';

export const isMySelectionSectionFilled = (filterState: DiscoverQs): boolean => {
  return Object.values(filterState).some((el) => el.length > 0);
};

